import { ButtonGroup, Button, Tooltip } from '@shopify/polaris';
import { SessionContext } from '#client/contexts/SessionContext.jsx';
import { useContext } from 'react';
import { hasPermission } from '#client/utils/helpers';
import { STATUS } from '#client/pages/CycleCounts/constants/cycleCount';
import { getCycleCountReopenError, hasCycleCountReopenPermission } from '#shared/cycleCountReopen.js';

const CycleCountActionButtons = ({ status, inventorySyncedAt, inventoryAppliedSkus, onApprove, onReject, onExport, onUpdateStatus, loadingStates }) => {
    const { currentUser } = useContext(SessionContext);

    const canManagerApprove = hasPermission(currentUser, 'ccManagerApprove');
    const canFinanceApprove = hasPermission(currentUser, 'ccFinanceApprove');

    const showApproveButton = (status === 'PENDING_MANAGER_APPROVAL' && canManagerApprove) || (status === 'PENDING_FINANCE_APPROVAL' && canFinanceApprove);
    const showRejectButton = (status === 'PENDING_MANAGER_APPROVAL' && canManagerApprove) || (status === 'PENDING_FINANCE_APPROVAL' && canFinanceApprove);

    const isWaitingOnManager = status === 'PENDING_MANAGER_APPROVAL' && !canManagerApprove;
    const isWaitingOnFinance = status === 'PENDING_FINANCE_APPROVAL' && !canFinanceApprove;

    const tooltipMessage = isWaitingOnManager ? 'Waiting for manager approval' : isWaitingOnFinance ? 'Waiting for finance approval' : '';

    const reopenError = hasCycleCountReopenPermission(currentUser?.role)
        ? getCycleCountReopenError({ status, inventorySyncedAt, inventoryAppliedSkus })
        : 'Reopening requires either Manager Approval or Finance Approval permission.';
    const canReopen = !reopenError;
    return (
        <ButtonGroup>
            <Tooltip content="Export cycle count details">
                <Button onClick={onExport} disabled={loadingStates.isExportLoading} loading={loadingStates.isExportLoading}>
                    Export
                </Button>
            </Tooltip>

            <Tooltip content={reopenError || 'Reopen this cycle count for editing'}>
                <Button onClick={() => onUpdateStatus(STATUS.IN_PROGRESS)} disabled={!canReopen || loadingStates.isUpdateStatusLoading} loading={loadingStates.isUpdateStatusLoading}>
                    Reopen
                </Button>
            </Tooltip>

            <Tooltip content={!showRejectButton ? tooltipMessage : 'Reject this cycle count'}>
                <Button tone="critical" onClick={onReject} disabled={!showRejectButton || loadingStates.isRejectLoading} loading={loadingStates.isRejectLoading}>
                    Reject
                </Button>
            </Tooltip>

            <Tooltip content={!showApproveButton ? tooltipMessage : 'Approve this cycle count'}>
                <Button variant="primary" onClick={onApprove} disabled={!showApproveButton || loadingStates.isApproveLoading} loading={loadingStates.isApproveLoading}>
                    Approve
                </Button>
            </Tooltip>
        </ButtonGroup>
    );
};

export default CycleCountActionButtons;
